export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/4b0863dc65497c154a239df5aef64a65.png";